import {
	CustomDetailCategory,
	DocumentTemplateStatus,
	DocumentWorkflowTemplateVisibleIn,
	TemplateAvailability,
} from '@dealstack/shared/lib/generated';

/** Label keys, not copy: the Select resolves them where a `t` is in scope. */
export const STATUS_OPTIONS = [
	{ value: DocumentTemplateStatus.DRAFT, labelKey: 'document_templates.assign.status.draft' },
	{
		value: DocumentTemplateStatus.PUBLISHED,
		labelKey: 'document_templates.assign.status.published',
	},
	{
		value: DocumentTemplateStatus.ARCHIVED,
		labelKey: 'document_templates.assign.status.archived',
	},
] as const;

/** The two audiences a library template may be offered to, in the order the drawer lists them. */
export const KYC_AUDIENCE_OPTIONS = [
	{
		value: DocumentWorkflowTemplateVisibleIn.KYC_INDIVIDUAL,
		labelKey: 'document_templates.assign.kyc.audience.individual',
	},
	{
		value: DocumentWorkflowTemplateVisibleIn.KYC_VEHICLE,
		labelKey: 'document_templates.assign.kyc.audience.vehicle',
	},
] as const;

/** `OTHER` is the Select's stand-in for a null category — the KYC review screen's last group. */
export const KYC_CATEGORY_NONE = 'OTHER';

export const KYC_CATEGORY_OPTIONS = [
	{
		value: CustomDetailCategory.TAX_RESIDENCY,
		labelKey: 'document_templates.assign.kyc.category.tax_residency',
	},
	{ value: CustomDetailCategory.FATCA, labelKey: 'document_templates.assign.kyc.category.fatca' },
	{ value: CustomDetailCategory.CRS, labelKey: 'document_templates.assign.kyc.category.crs' },
	{ value: CustomDetailCategory.GDPR, labelKey: 'document_templates.assign.kyc.category.gdpr' },
	{ value: KYC_CATEGORY_NONE, labelKey: 'document_templates.assign.kyc.category.other' },
] as const;

export interface TemplateAvailabilityFormValues {
	status: DocumentTemplateStatus;
	availability: TemplateAvailability;
	dealIds: string[];
	kycAudience: DocumentWorkflowTemplateVisibleIn[];
	kycCategory: CustomDetailCategory | null;
}

export interface UseTemplateAvailabilityFormArgs {
	templateId: string;
	onSaved: () => void;
}
